import React from "react";

const SvgOval = props => (
  <svg width={239} height={239} {...props}>
    <circle
      cx={206.5}
      cy={218.5}
      r={117.5}
      fill="none"
      stroke="#48314A"
      strokeWidth={4}
      transform="translate(-87 -99)"
    />
  </svg>
);

export default SvgOval;
